/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Right-to-left",
		"timeZoneID": "Time zone",
		"skin": "Style",
		"metricsFileImportTask": "New Import from Files",
		"displayMode": "Default view",
		"credentialRenewed": "Your credentials were renewed with your current user ID and password.",
		"productLocale": "Product language",
		"toggleDisabled": "off",
		"credentialChange": "Renew",
		"log_level_Debug": "Debug",
		"confirmNewPassword": "Confirm new password",
		"unsavedViewMsg2": "Your changes will be lost if you don't save them first.",
		"supportPortalErrorMessage": "Try again.  If the problem persists, contact your administrator.",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, the IBM logo, ibm.com and Cognos are trademarks or registered trademarks of International Business Machines Corp., registered in many jurisdictions worldwide. A current list of IBM trademarks is available on the Web at www.ibm.com/legal/copytrade.shtml. This Program is licensed under the terms of the license agreement accompanying the Program. This license agreement may be either located in a Program directory folder or library identified as \"License\" or \"Non_IBM_License\" if applicable, or provided as a printed license agreement. Please read the agreement carefully before using the Program. By using the Program you agree to these terms.",
		"groupsAndRoles": "Groups and roles",
		"metricsMaintenanceTask": "New Maintenance",
		"email": "Email",
		"contextual": "Contextual",
		"resetHome": "Reset to default",
		"ltr": "Left-to-right",
		"credentials": "Credentials",
		"logging_congfig_title": "Logging",
		"changePasswordTitle": "Change my password",
		"format": "Report format",
		"showUnread": "Show unread",
		"AILearning_active": "AI Learning is on:",
		"docsErrorMessage": "Try again.  If the problem persists, contact your administrator.",
		"toggleEnabled": "on",
		"homeSetError": "An error occurred setting the default home page, try closing and reopening this view.",
		"passwordChange": "Change your password",
		"profile": "Profile",
		"pdfRestricted": "PDF (Restricted)",
		"drillThrough": "Drill-Through definitions",
		"homeSet": "Your home was set successfully",
		"regionalOptions": "Regional options",
		"myPreferences": "My preferences",
		"defaultHome": "Default",
		"version": "Version",
		"controller": "Controller",
		"manage": "Manage",
		"biDirectionalFeaturesEnabled": "Bidirectional language support",
		"newFeaturesErrorTitle": "The link to New Features did not work",
		"passwordMatch": "Password match",
		"updateProfileAndsettings": "Update profile and settings",
		"dashboardConsole": "Workspace",
		"legacyAppsSlideoutLabel": "Available Legacy Applications",
		"logging_config_description": "Logging is used for troubleshooting. Consult your administrator for guidance on settings.",
		"confirmDeletion": "Confirm deletion",
		"signInButtonText": "Log in",
		"dataSourceCredentials": "Data server credentials",
		"AILearningConfigurationSlideoutAllyLabel": "AI learning configuration",
		"loadingSettings": "Loading settings",
		"spreadsheetMLRestricted": "Excel (Restricted)",
		"manageAILearning": "AI learning",
		"xlsxDataRestricted": "Excel Data (Restricted)",
		"advanced": "Advanced options",
		"ok": "OK",
		"changeEmail": "Change",
		"showHints": "Show hints",
		"general": "General",
		"xlsxData": "Excel Data",
		"newPassword": "New password",
		"hideAll": "Hide all",
		"confirmPassword": "Confirm password",
		"AILearning_config_description": "Improve in-product recommendations by allowing Cognos Analytics to learn about your usage.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "The link to Support Portal didn't work",
		"log_level_Warn": "Warning",
		"contentSettings": "Content settings",
		"setHomeButton": "Set",
		"myCapabilities": "My capabilities",
		"homePage": "Home page",
		"helpErrorMessage": "Try again.  If the problem persists, contact your administrator.",
		"loadingProfile": "Loading profile",
		"portal": "Portal",
		"metricsPackage": "New Package",
		"myCredentials": "My credentials",
		"myApiKeys": "My API keys",
		"credentialCreate": "Create",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Unable to update password",
		"showHiddenObjects": "Show hidden entries",
		"csv": "CSV",
		"docsErrorTitle": "The link to Documentation didn't work",
		"log_level_Error": "Error",
		"wrongPassword": "Unable to authenticate",
		"productName": "IBM Cognos Analytics with Watson %{version}",
		"log_level_Info": "Information",
		"welcomeBanner": "Welcome banner",
		"helpErrorTitle": "The link to Help didn't work",
		"contentLocale": "Content language",
		"pdf": "PDF",
		"oldPassword": "Old password",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Accessibility features",
		"manageLogging": "Logging",
		"loggingConfigurationSlideoutA11yLabel": "Logging Configuration",
		"communityErrorTitle": "The link to Community didn't work",
		"companionApps": "Companion applications",
		"setHomeLabel": "Set home as (current view)",
		"metricsExportTask": "New Export",
		"csvRestricted": "CSV (Restricted)",
		"newFeaturesErrorMessage": "Try again.  If the problem persists, contact your administrator.",
		"contributor": "Contributor",
		"showAll": "Show all",
		"logging_active": "Logging is on:",
		"html": "HTML",
		"profileAndSettings": "Profile and settings",
		"baseTextDirection": "Base direction for text",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Password",
		"invalidEmail": "Enter a valid email address",
		"credentialCreateSuccess": "You have successfully created your credentials",
		"settings": "Settings",
		"restrictedFormatSelected": "You do not have the capability to run reports in this format, but you can access reports that are saved in this format.",
		"usageDataDeletionConfirmation": "Deleting usage data resets any AI learning.  Are you sure you want to delete usage data?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "View details",
		"deleteUsageData": "Delete usage data:",
		"showPassword": "Show password",
		"AILearning_config_title": "AI learning",
		"myPreferencesSlideoutLabel": "Profile and settings",
		"passWordChangeSuccess": "You have successfully changed your password",
		"logging_level": "Logging level:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Try again.  If the problem persists, contact your administrator.",
		"cancel": "Cancel",
		"shareSetError": "This action cannot be performed before closing and reopening this view.",
		"passwordNotMatch": "Oops, password does not match",
		"xml": "XML",
		"xmlRestricted": "XML (Restricted)",
		"openMenu": "Open menu",
		"closeMenu": 'Close menu'
});